var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForeman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89419 13.3914C3.72392 12.7224 3.8942 12.0001 4.15092 11.4579L5.02459 12.241C4.91617 12.4503 4.8901 12.7597 4.98504 13.1328C5.07238 13.476 5.33457 13.8935 6.06942 14.2178L6.3126 14.3251L6.37962 14.575C6.66893 15.6536 7.31285 17.2765 8.28774 18.6161C9.27237 19.9691 10.5037 20.9157 11.9515 20.9157C13.3953 20.9157 14.5948 19.9736 15.5393 18.6242C16.4753 17.2871 17.0736 15.6662 17.3328 14.5883L17.4221 14.217L17.8143 14.1724C18.0506 14.1456 18.394 14.0146 18.6219 13.7258C18.8324 13.4591 19.0138 12.9688 18.7719 12.0772L19.752 11.3374C20.2513 12.482 19.9833 13.79 19.5155 14.3828C19.182 14.8055 18.7395 15.0481 18.3411 15.1672C18.025 16.3215 17.4079 17.8915 16.47 19.2313C15.4468 20.6931 13.9525 22 11.9515 22C9.95462 22 8.42977 20.6976 7.36859 19.2394C6.36896 17.8658 5.6999 16.2491 5.35993 15.088C4.50614 14.646 4.05728 14.0323 3.89419 13.3914Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96057 5.07229C7.00896 3.6747 9.10159 3.04418 10.0169 2.90361V7.12048H10.8281V2.90361C10.8697 2.60241 11.1651 2 12.0138 2C12.8625 2 13.1995 2.60241 13.2619 2.90361V7.12048H13.9483V2.90361C14.2603 3.0241 16.2573 3.56626 17.5678 4.6506C18.6162 5.51807 19.7519 7.54217 20.1887 8.44578C20.7379 8.34939 20.9584 8.68674 21 8.86747V9.46988L17.0685 12.5422H6.52219L3.02757 9.46988C3.00676 9.38955 2.97764 9.13253 3.02757 8.74698C3.07749 8.36144 3.63081 8.38554 3.90123 8.44578C4.15084 7.90361 4.91218 6.46988 5.96057 5.07229Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeman);
export default __webpack_public_path__ + "static/media/foreman.5654750e027ae94a0dbb88ba6f249076.svg";
export { ForwardRef as ReactComponent };